// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"139e1cc0","892":"90870a2c"}[chunkId] + ".chunk.js";
};